import React from "react";
import styles from "../../organisms/NumberTransfer/numberTransfer.module.scss";
import { NumberTransferCBU } from "../../organisms/NumberTransfer/NumberTransfer";
import config from "../../../config";

const NumberTransferInfoBox = () => {
  const [showInfo, setShowInfo] = React.useState(false);
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const context = React.useContext(NumberTransferCBU);
  const content = ((context?.sections || [])[1]?.items || [])[0]?.description;
  const title = (context?.sections || [])[1]?.title;
  if (!content || !title) {
    return null;
  }
  return (
    <div className={styles["number-transfer-step__infobox-wraper"]}>
      <p className={styles["number-transfer-step__subtitle"]}>
        <span>{title}</span>
        <span onClick={() => setShowInfo((show) => !show)}>
          <span>Important info</span>{" "}
          <img
            src={`${imagePrefix}/assets/images/collapsible.svg`}
            className={`${
              showInfo && styles["number-transfer-step__icon-hide"]
            }`}
          />
        </span>
      </p>
      <p
        className={`${styles["number-transfer-step__infobox"]} ${
          !showInfo && styles["number-transfer-step__infobox-hide"]
        }`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default NumberTransferInfoBox;
